import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const flightAware = defineConnector({
  identifier: "flightAware",
  name: "FlightAware",
  tagLine: "Live flight tracking and status",
  keywords: "flightaware aeroapi flights tracking aviation airports arrivals",
  logo,
  protocol: "http",
  tags: ["travel"],
  defaultUrlPattern: () => domainToRegex("aeroapi.flightaware.com/aeroapi"),
  auth: (app) => headerAuth([{ name: "x-apikey", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Create an AeroAPI key",
      items: [
        {
          kind: "markdown",
          content:
            "Sign up at [flightaware.com/aeroapi](https://www.flightaware.com/commercial/aeroapi/) and create a key under **AeroAPI › My Account**. AeroAPI bills per query, so pick the tier that matches your volume.",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://aeroapi.flightaware.com/aeroapi/me",
  },
});
